import { SET_TABLE, SET_RESID } from "../actions/qrAction";

const initialState = {
  resID: "5f4a6c9dd83e7d641b32448e",
  tableNum: 1,
};

const qrReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TABLE:
      console.log(action.payload);
      return {
        ...state,
        tableNum: action.payload,
      };
    case SET_RESID:
      console.log(action.payload);
      return {
        ...state,
        resID: action.payload,
      };
    default:
      return state;
  }
};

export default qrReducer;
